import { css } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import { wacToken } from '@/libraries/design/foundations';

const containerStyles = css({
	padding: token('space.200'),
	backgroundColor: wacToken('color.neutral.light200'),
});

const textStyles = css({
	margin: 0,
	whiteSpace: 'pre-wrap',
	wordBreak: 'break-word',
	fontFamily: token('font.family.code'),
	fontWeight: 400,
	lineHeight: 1.56,
	letterSpacing: '-0.01em',
	color: 'var(--wac-color-body)',
});

export type UniformPromptBlockProps = {
	/** The text content to render in monospace typography */
	text: string;
};

const UniformPromptBlock = ({ text }: UniformPromptBlockProps) => {
	return (
		<div css={containerStyles}>
			<p className="body-mono" css={textStyles}>
				{text}
			</p>
		</div>
	);
};

export default UniformPromptBlock;
